/* eslint-disable new-cap */
/* eslint-disable camelcase */
import Vue from "vue"
import VueI18n from "vue-i18n"
import deliveryMethodComponent from "../deliveryMethod.vue"
import { getLang } from "@/plugins/env"
import en_US from "@/assets/lang/en"
import zh_HK from "@/assets/lang/zh"
const deliveryMethodCom = Vue.extend(deliveryMethodComponent)
let instance = null
const defaults = {
  deliveryMethodValue: "homeDelivery"
}

const deliveryMethod = {
  open(options = {}) {
    return new Promise((resolve, reject) => {
      if (instance) {
        instance.visible = false
      }
      const optionsObj = Object.assign(defaults, options)
      const i18n = new VueI18n({
        locale: getLang(),
        messages: {
          en_US,
          zh_HK
        }
      })
      instance = new deliveryMethodCom({
        el: document.createElement("template"),
        i18n,
        propsData: optionsObj
      })
      instance.callback = action => {
        if (action === "close") {
          resolve("close")
        }
      }
      instance.visible = true
      document.body.appendChild(instance.$el)
    })
  },
  close() {
    instance.visible = false
  }
}
export default {
  install() {
    if (!Vue.$deliveryMethod) {
      Vue.$deliveryMethod = deliveryMethod
    }
    Vue.mixin({
      created() {
        this.$deliveryMethod = Vue.$deliveryMethod
      }
    })
    Vue.component("DeliveryMethod", deliveryMethodComponent)
  }
}
